import { useState } from 'react'
import { initials } from '../lib/format'

interface AvatarProps {
  name: string
  src: string | null
  size?: number
  className?: string
}

export function Avatar({ name, src, size = 32, className = '' }: AvatarProps) {
  const [broken, setBroken] = useState(false)
  const style = { width: size, height: size, fontSize: Math.round(size * 0.38) }
  const base = `inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-surface font-medium text-muted ring-1 ring-inset ring-line ${className}`

  if (src && !broken) {
    return (
      <span className={base} style={style}>
        <img
          src={src}
          alt=""
          width={size}
          height={size}
          referrerPolicy="no-referrer"
          className="size-full object-cover"
          onError={() => setBroken(true)}
        />
      </span>
    )
  }
  return (
    <span className={base} style={style} aria-hidden>
      {initials(name)}
    </span>
  )
}
